"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagIcon = void 0;
const core_shared_1 = require("@ikegps/core-shared");
const theme_1 = require("../../components/theme");
const mithril_1 = require("../../mithril");
const tag_icon_style_1 = require("./tag.icon.style");
(0, theme_1.addStyles)(tag_icon_style_1.Style);
exports.TagIcon = {
    view(tag, summary, color) {
        const value = summary != null ? summary.revisions.length : null;
        return (0, mithril_1.m)('div', {
            className: tag_icon_style_1.CSS.container,
            style: {
                'border-color': core_shared_1.ColorHash.hash(tag.objectId),
                'background-color': color ? color : '#FFFFFF',
            },
        }, value);
    },
};
//# sourceMappingURL=tag.icon.js.map